var GateState = /* @__PURE__ */ ((GateState2) => {
  GateState2[GateState2["Undefined"] = 0] = "Undefined";
  GateState2[GateState2["NotSet"] = 1] = "NotSet";
  GateState2[GateState2["Waiting"] = 2] = "Waiting";
  GateState2[GateState2["Passed"] = 3] = "Passed";
  GateState2[GateState2["Overridden"] = 4] = "Overridden";
  GateState2[GateState2["Failed"] = 5] = "Failed";
  return GateState2;
})(GateState || {});
export {
  GateState
};
//# sourceMappingURL=gateState.js.map
